import React, {Component, Fragment} from 'react';
import {inject, observer} from 'mobx-react';

@inject('lineStore', 'dictStore')
@observer
export default class FilterTimeLine extends Component {

  state = {
    show: false
  };

  handleClear = (e) => {
    this.props.lineStore.line.filterLine(0);
  };

  handleClick = (value) => {
    this.props.lineStore.line.filterLine(value);
    this.hideItems();
  };

  showItems = () =>{
    this.setState({show: true})
  };

  hideItems = () =>{
    this.setState({show: false})
  };

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside = (e) => {
    const items = document.querySelector('.time-select-list-items');

    if (items && !items.contains(e.target)) {
      this.hideItems();
    }
  };

  render() {

    const {timeLineFilter, timeLine} = this.props.lineStore.line;
    const {getLang} = this.props.dictStore;
    const {show} = this.state;

    return (
      <Fragment>
				<span className="control-panel-item time-select">
					{timeLineFilter.map(el => <div
            className={`white-btn timeline-item ${el.val == timeLine ? 'selected' : ''}`}
            onClick={() => this.handleClick(el.val)}
            key={el.val}>{getLang(el.label)}</div>)}
				</span>

        <div className="time-line-filter-select time-select-list white-btn" onClick={this.handleChange}>
          <div className="time-select-list-current" onClick={this.showItems}>
            {timeLineFilter.map(item => item.val == timeLine ? getLang(item.label) : null)}  <span className=" icon f-s-ico-arrow_buttom_1"/>
          </div>
          {
            show ?
              <div className="time-select-list-items">
                {
                  timeLineFilter.map(el => <div className={`white-btn time-select-list-item ${el.val == timeLine ? 'selected' : ''}`} onClick={() => this.handleClick(el.val)} key={el.val}>{getLang(el.label)}</div>)
                }
              </div>
              : null
          }
        </div>

        {/*{timeLine != 0 ? */}
        {/*	<span className="control-panel-item" onClick={this.handleClear}>*/}
        {/*		<button className="time-line-filter-clear" title="Сбросить фильтр">×</button>*/}
        {/*	</span> : ''}*/}
      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/line/filterTimeLine.jsx